const homePageDataFields = `featuredCampaigns{
      description
      backgroundColor{
        backgroundColor
      }
      darkBackgroundColor{
        backgroundColor
      }
      campaignMedia{
        url
        mimeType
        coverImage{
          url
        }
        sizes{
          medium{
            url
          }
        }
      }
      campaign{
        id
        slug   
    }
}
  featuredProfiles{
        publicProfiles{
          slug
          stories{
            title
            images{
              url
              sizes{
                webp{
                    url
                }
                thumbnail{
                    url
                }
        }
            }
          }
          profileImage{
            url
            sizes{
             medium{
              url
             }
            }
          }
          overview
          profileEntity{
            universities{
              name
            }
            fullName
            region
            status
            organizations{
              name
            }
          }
          id
        }
        legacyProfiles{
          id
          slug
          fullName
          stories{
            title
            images{
              url
              sizes{
                webp{
                    url
                }
                thumbnail{
                    url
                }
          }
            }
          }
          published
          organizations{
            organization
          }
          profileImage
          universities{
            name
          }
          description
          region
          state
          professions{
            profession
          }
        }
    }
    featuredVideos{
      title
      description
      videoId
      source
      additionalVideos {
        title
        videoId
        source
      }
}
`
const profileRelationAndValueFields = `
    relationTo
    value{
        ... on Legacyprofile{
            id
            slug
            fullName
            region
            description
            legacyProfileImage: profileImage
        }
        ... on Publicprofile{
            id
            slug
            _status
            profileEntity{
                status
                fullName
                region
            }
            meta{
                description
            }
            publicProfileImage: profileImage{
                sizes{
                    webp{
                        url
                    }
                    medium{
                        url
                    }
                    thumbnail{
                        url
                    }
                }
            }
        }
    }
`

const profileListDataFields = `
    profileList{
        keyProfile
        profile{
            ${profileRelationAndValueFields}
        }
    }
    listFormat
`

const regularProfileListDataFields = `
    regularHasManyProfileList: hasManyProfileList{
        ${profileRelationAndValueFields}
    }
`

const compactProfileListDataFields = `
    compactHasManyProfileList: hasManyProfileList{
        ${profileRelationAndValueFields}
    }
`

const keyProfileListDataFields = `
    keyHasManyProfileList: hasManyProfileList{
        ${profileRelationAndValueFields}
    }
`

export const homePageCampaignDataFields = `
    id
    block{
        ... on RegularProfileList{
            id
            blockType
            blockName
            ${regularProfileListDataFields}
        }
        ... on CompactProfileList{
            id
            blockType
            blockName
            ${compactProfileListDataFields}
        }
        ... on KeyProfileList{
            id
            blockType
            blockName
            ${keyProfileListDataFields}
        }
        ... on ProfileList{
            id
            blockType
            blockName
            ${profileListDataFields}
        }
    }
    title
    slug
    publishDate
    coverimage{
        sizes{
            medium{
                url
            }
        }
    }
`
export default homePageDataFields
